import React from 'react';
import { Activity } from 'botframework-directlinejs';
import { type ActivityRenderer } from '@bingads-webui-react/msa-copilot-common';
import { LiveAgentInteractionCard } from '../index';

export const LiveAgentInteractionCardRenderer: ActivityRenderer = (props) => {
  const {
    activity,
    params,
    logger,
  } = props;

  return (
    <LiveAgentInteractionCard
      activity={activity}
      params={params}
      logger={logger}
    />
  );
};

LiveAgentInteractionCardRenderer.canRender = (activity: Activity, isFromUser: boolean) => !isFromUser
  && activity.type === 'message'
  && (activity.value as any) === 'LiveAgentMessage';
